import { Tooltip, Alert } from "bootstrap";

import { utils } from "@shop/frontend/web/js/utils";
import { googleAnalytics } from "@shop/frontend/web/js/components/googleAnalytics";
import { saveUtmToCookie } from "@shop/frontend/web/js/utils/utm";
import { hamburger } from "@shop/frontend/web/js/components/hamburger";
import { QuantityCounter } from "@shop/frontend/web/js/components/QuantityCounter";
import { Modal } from "@shop/frontend/web/js/components/Modal";
import { translator } from "@shop/frontend/web/js/services/TranslatorService";
import { emailRestriction } from '@shop/frontend/web/js/components/emailRestriction';
import RegisterForm from "./classes/RegisterForm";

export class App {
	constructor() {}

	init(params = {}) {
		$(".dropdown").ariaDropdown();
		$.each($("[data-bs-toggle=tooltip]"), (i, tooltip) => new Tooltip(tooltip, {}));
		$.each($(".alert"), (i, alert) => {
			const bpAlert = new Alert(alert);
			$(alert)
				.find(".btn-close")
				.on("click", () => bpAlert.close());
		});

		utils.addVoidForLinks($("a"));

		hamburger("js-hamburger", "js-menu");

		if (window.gaEnabled) googleAnalytics();
		saveUtmToCookie();
		this.initFastRegistration();
		this.initToggleActiveClass();
		this.initQuantityCounter();
		this.modal = new Modal({ className: "i-modal_alert" });
		if ($("#registerModal").length) this.registerModal = new Modal().use("registerModal");
		this.refundModal = new Modal({ className: "i-modal_refund" });
		this.refundSuccessModal = new Modal({ className: "i-modal_refund-success" });
		if ($("#fastRegisterModal").length)
			this.fastRegisterModal = new Modal().use("fastRegisterModal");

		if (params.CartService) CartService.getCount();

		this.setUpListeners();
		this.setUpModalListeners();
		this.setUpFormListeners();
		if ($("#js-access").length > 0) this.setUpAccessListeners();

		this.initTicketReturn();
		emailRestriction();
		const registerForm = new RegisterForm('#registration-form');
		registerForm.init();
		const fastbuyForm = new RegisterForm('#fast-registration-controller');
		fastbuyForm.init();
	}

	setUpListeners() {
		$(document).on("click", "#js-hide-play-info", e => {
			const element = $(e.currentTarget);
			const parent = element.parents(".play-info");
			parent.remove();
		});

		$(document).on("click", ".js-event-more", e => {
			const element = $(e.currentTarget);
			const parent = element.parents(".js-text-parent");
			element.toggleClass("active");
			parent.find(".js-event-text").slideToggle();
		});

		$(".js-toggle-long-text").on("click", e => {
			$(e.currentTarget).toggleClass("active").prev().toggleClass("short");
			const text = $(e.currentTarget).find("span");

			text.text(translator.t("main", "Show description"));

			if ($(e.currentTarget).hasClass("active"))
				text.text(translator.t("main", "Hide description"));
		});

		$(document).on("mouseout", ".js-hover-out", e => {
			const element = $(e.currentTarget);
			element.blur();
		});
	}

	setUpFormListeners() {
		$(".enter form").on("submit", e => {
			const $form = $(e.currentTarget);
			const $button = $form.find("button[type='submit']");
		
			$button.addClass("disabled");
		});

		$(".checkbox__input").on("keydown", e => {
			const element = $(e.currentTarget);

			if (e.code === "Enter" || e.code === "NumpadEnter") {
				element.toggleClass("checked");

				if ($(element).hasClass("checked")) {
					$(element).prop("checked", true);
				} else {
					$(element).prop("checked", false);
				}
			}
		});

		$(document).on("click", ".js-enter-visible-password", e => {
			const element = $(e.currentTarget);
			const input = element.parents(".enter__block").find(".enter__input");
			element.toggleClass("active");

			if (input.attr("type") === "text") {
				input.attr("type", "password");
				element.attr(
					"aria-label",
					"Show password as plain text. " +
						"Warning: this will display your password on the screen."
				);
			} else {
				input.attr("type", "text");
				element.attr("aria-label", "Hide password.");
			}
		});

		$.each($(".form-group input"), (i, item) => {
			const element = $(item);
			if (element.val()) {
				element.next().addClass("inactive");
			}
		});

		$(".form-group input").on("input", e => {
			const element = $(e.currentTarget);
			element.next().addClass("inactive");
			if (!element.val()) {
				element.next().removeClass("inactive");
			}
		});

		$(".form-group input").on("click", e => {
			const element = $(e.currentTarget);
			element.next().addClass("inactive");
		});

		$(".form-group input").on("blur", e => {
			const element = $(e.currentTarget);
			if (!element.val()) {
				element.next().removeClass("inactive");
			}
		});

		$('.checkbox_register input[type="checkbox"]').on("change", e => {
			const $element = $(e.currentTarget);
			const value = Number($element.val());
			if (value === 1) {
				$element.prev().val(0);
				$element.val(0);
			} else {
				$element.prev().val(1);
				$element.val(1);
				$(".js-fast-btn").removeClass("disabled");
				$(".js-login-btn").removeClass("disabled");
			}
		});
	}

	setUpModalListeners() {
		$(".js-get-access-modal").on("click", e => {
			if (this.registerModal) this.registerModal.hide(e);
			const initial = $(e.currentTarget).data("initial");
			$(".access-request__link").hide();
			$(`.access-request__link[data-initial="${initial}"]`).show();
		});

		$(document).on("click", ".js-get-modal", e => {
			const $element = $(e.currentTarget);
			const modal = $element.data("target");

			$(".modal").modal("hide");
			if (this.fastRegisterModal) this.fastRegisterModal.hide();
			$(modal).modal("show");
		});

		$(".modal").on("shown.bs.modal", function (e) {
			$("body").addClass("modal-open");
		});
	}

	setUpAccessListeners() {
		$(".js-sphere-item").on("click", e => {
			const element = $(e.currentTarget);
			const index = element.index() + 1;
			const selectedText = element.text();
			$("#requestadmin-activity_sphere")[0][index].selected = true;
			$("#js-dropdown-sphere").ariaDropdown("slideUp");
			$("#js-dropdown-sphere .dropdown__btn").find("span").text(selectedText);
		});

		$(".js-access-radio").on("change", e => {
			const element = $(e.currentTarget);
			const type = element.val();
			$(".js-access-content").hide();
			$(`.js-access-content[data-type='${type}']`).show();
		});

		$("#js-access-hide").on("click", () => {
			$("#js-access").slideUp();
			utils.setCookie("accessHide", true, { path: "/", "max-age": "36000000" });
		});

		$("#js-close-access").on("click", () => $("#js-access").slideUp());
	}

	initQuantityCounter() {
		$.each(
			$(".js-quantity-counter"),
			(i, quantityCounter) => new QuantityCounter(quantityCounter)
		);
	}

	initFastRegistration() {
		$(document).on("click", ".js-get-fast-registration", e => {
			const el = $(e.currentTarget);
			e.preventDefault();
			this.fastRegisterModal.show();
			const sum = el.parents(".js-order").find(".js-sum").text();
			$(".js-sum-fast").text(sum);
			let action = $("#fast-registration-controller").attr("action");
			const eventId = $(el.parents(".js-order").find(".js-order-event")[0]).data("event-id");
			const resultID = action.match(/event_id=\d*/);
			action = action.replace(resultID, `event_id=${eventId}`);
			$("#fast-registration-controller").attr("action", action);
		});
	}

	initToggleActiveClass() {
		$(document).on("click", ".js-toggle-active", e => {
			const target = $(e.currentTarget).data("toggle-target");

			$(e.currentTarget).toggleClass("active");

			if (target) return $(target).toggleClass("active");
		});
	}


	initTicketReturn() {
		if (!$(".js-ticket-return").length > 0) return false;

		$(".js-ticket-return").on("click", e => {
			const $element = $(e.currentTarget);
			const orderId = $element.data("order");
			const eventId = $element.data("event");
			const fragment = document.importNode($("#js-template-refund")[0].content, true);
			const returnConfirm = $(fragment).find("#js-return-confirm");
			returnConfirm.data("order", orderId);
			returnConfirm.data("event", eventId);
			$("#js-popup-modal").find(".modal-body").html(fragment);
			$("#js-popup-modal").addClass("modal_refund");
			$("#js-popup-modal").modal();
		});

		$(document).on("click", "#js-return-confirm", e => {
			const $element = $(e.currentTarget);
			const orderId = $element.data("order");
			const eventId = $element.data("event");

			this.requestTicketReturn(orderId, eventId)
				.then(res => {
					if (!res.success) throw new Error(res.message);

					return window.location.reload();
				})
				.catch(err => {
					console.log(err);
					alert(`Произошла ошибка!\n${err.message || "Неизвестная ошибка с сервера!"}`);
				});
		});
	}
	
}
